import { Skeleton } from '../ui/skeleton';

const XPActivityCalendarCardSkeleton = () => {
    return (
        <div className="border border-neutral-300 rounded-xl p-4">
            <div className="flex justify-between items-center mb-4">
                <Skeleton className="h-6 w-1/3" />
                <Skeleton className="h-8 w-20" />
            </div>
            <div className="grid grid-cols-10 gap-0.5 flex flex-col gap-0.5">
                {Array.from({ length: 60 }).map((_, i) => (
                    <div key={i} className="w-full">
                        <Skeleton className="h-4 w-4" />
                    </div>
                ))}
            </div>
            <div className="flex justify-between items-center my-4">
                <Skeleton className="h-8 w-20" />
            </div>
        </div>
    );
};

export default XPActivityCalendarCardSkeleton;
